var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "my_dia",
          attrs: { title: "Withdraw Rewards", visible: _vm.open },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c("div", { staticClass: "con" }, [
            _c("p", [
              _c("i", { staticClass: "el-icon-warning" }),
              _vm._v(" Are you sure you want to withdraw all rewards?"),
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("Rewards:\n        "),
                _c("big-number", {
                  staticClass: "num",
                  attrs: { number: _vm.row.rewards },
                }),
                _vm._v("\n        UNIT\n      "),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.open = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleWithdraw },
                },
                [_vm._v("Withdraw")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("handle", { ref: "handleCom", on: { success: _vm.handleSuccess } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }